/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'pip-model',
    'pip-events',
    'window'
],
function(
    pip,
    pipEvents,
    window
){

	function initEventListeners(){
		pipEvents.media.expandMediaView.on('.analyticsExpandedMediaView', function(evtType, data){
			pushAnalyticsEvent(data.analyticsMessage);
		});

		pipEvents.expressDelivery.expressDeliveryOverlayLinkClicked.on('.analyticsExpressDeliveryOverlayLinkClicked', function(evtType, data){
			pushAnalyticsEvent(data);
		});


      pipEvents.ecoRebates.ecoRebatesLinkClicked.on('.analyticsEcoRebatesLinkClicked', function(evtType, data){
        pushAnalyticsEvent(data);
      });
	}

	function pushAnalyticsEvent(event){
	  var analyticsObj;
    if (event.eventName === 'available rebates') {
      analyticsObj = {
              category: {
                primaryCategory: 'overlay'
              },
              eventInfo: {
                eventName: event.eventName || ''
              }
            }
    }
    else if (event.eventName === 'expanded view' || event.eventName === 'view delivery faqs' || event.eventName === 'mail in rebate') {
      analyticsObj ={
          category: {
            primaryCategory: 'overlay'
          },
          eventInfo: {
            eventName: event.eventName || ''
          },
          item: [
            {
              productInfo: {
                sku: event.sku ? event.sku : pip.products
              }
            }
          ]
        }
      if(event.availability) {
        analyticsObj.item[0].productInfo.availabilityStatus = {
          shipping: {
            bodfs: event.availability
          }
        }
      }
    }

		if (pip.debugMode) console.log('DDO Overlay Event', analyticsObj);

		if(window.digitalData && window.digitalData.event) window.digitalData.event.push(analyticsObj);

	}

	return {
		init: function(){
			initEventListeners();
		}
	}
});

}.call(window));